import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CustomerPort } from '../domain/customer'

const deleteCustomer = async (port: CustomerPort, id: string, notify: NotifyPort): Promise<void> => {
	try {
		await port.delete(id)
		notify.success('customer.deleted')
	} catch (err) {
		notify.error('customer.deleteFailed')
		throw err
	}
}

export { deleteCustomer }
